import React from "react";
import UpperHeader from "../../components/header/UpperHeader";
import Header from "../../components/header/Header";
import Subtitle from "../../components/subtitle/Subtitle";
import Paragraph from "../../components/paragraph/Paragraph";
import Title from "../../components/title/Title";
import Button from "../../components/button/Button";
import Footer from "../../components/footer/Footer";

const AboutIGEM: React.FC = () => {
  return (
    <div>
      <UpperHeader />
      <Header pageTitle="活動実績" />
      <Title text="活動実績" />

      <Subtitle text="2026/8/14　イベント「ふしぎな菌の世界を学ぼう」" />
      <Paragraph text="小学生のみなさんと一緒に、納豆菌と麹菌を「絵の具」にしてシャーレにお絵かきをするワークショップを行いました。培養したシャーレの写真は、下のページで公開しています。" />
      <Button
        label="シャーレの写真を見る"
        textColor="#F59A23"
        backgroundColor="#FFFFFF"
        link="/activity/fungi_world"
      />

      <Subtitle text="2024/2/28　東洋大学京北高等学校での第3回education" />
      <Paragraph text="筑波大学キャンパスツアーを実施し、大学や生物学への理解を深めてもらいました。" />

      <Subtitle text="2024/2/14　埼玉県立越谷北高校での第2回education" />
      <Paragraph text="研究のプロセスを体験できるアクティビティーを行いました。" />

      <Subtitle text="2024/11/23　テクノアイディアコンテスト2024 健闘賞獲得" />
      <Paragraph text="iGEM TSUKUBAのアイディアが世に認められました。" />

      <Subtitle text="2024/10/23　東洋大学京北高等学校での第2回education" />
      <Paragraph text="ピペットマンの詳細な使用方法などについて講義行いました。" />

      <Subtitle text="2024/10/22　埼玉県立越谷北高校での第1回education" />
      <Paragraph text="生徒さんのテーマに対してアドバイス等を行い、研究活動をお手伝いしました。" />

      <Subtitle text="2024/9/4　東洋大学京北高等学校での第1回education" />
      <Paragraph text="カルタヘナ法をはじめとした遺伝子組換え実験に関わる法規制や取るべき措置について講義を行いました。" />

      <Button
        label="詳しくはこちら"
        textColor="#D20000"
        backgroundColor="#FFFFFF"
        link="/activity/news"
      />
      <Footer />
    </div>
  );
};

export default AboutIGEM;
